<div class="row justify-content-center px-4">
  <div class="col-12 reflection py-4 px-4 text-center">
    <img src="../../../../assets/star.svg">
    <h3 class="mt-4" [innerHTML]="title"></h3>
    <p class="mt-4 mb-0 text-left" [innerHTML]="p"></p>
  </div>
</div>
